import { BaseRequest } from 'src/app/tools/models/dtos/base-request';import { Partner } from '../../entities/master-data/partner-entity';import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class PartnerRequest extends BaseRequest{
  partner : Partner;
  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.partner = new Partner();
  }
}